import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useUpdatePricingConfiguration = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (
      vars: Parameters<typeof apiClient.updatePricingConfiguration>[0] & {
        porgId: number;
      },
    ) => {
      await apiClient.updatePricingConfiguration(vars, {
        params: {
          porgId: vars.porgId,
        },
      });
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [{ entity: "pricing_configuration" }],
      });
    },
  });
};
